export function SkillEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="136"
        viewBox="0 0 200 136"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M63.3806 20.5066C66.2662 28.9988 71.6914 34.9534 79.6561 38.3702"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M58.6548 16.3031C54.7834 10.2193 56.9106 4.26323 62.9305 3.39113C64.8024 9.43233 62.6964 14.3886 58.6548 16.3031Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M58.6551 16.303C52.6139 18.1749 47.7001 14.0694 47.8278 8.07078C53.8264 8.19846 57.7617 11.2829 58.6551 16.303Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M62 43C62 37.6667 64.6667 35 70 35H130C135.333 35 138 37.6667 138 43V85C138 103.667 125.333 119.667 100 133C74.6667 119.667 62 103.667 62 85V43Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 56L102.323 62.2213L109 62.5106L103.702 66.634L105.516 73L100 69.3106L94.4839 73L96.2984 66.634L91 62.5106L97.6774 62.2213L100 56Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M84 93C88 97.6667 92 97.6667 96 93"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 93C108 97.6667 112 97.6667 116 93"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 107C97.3333 111 102.667 111 108 107"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 105.5C80.1569 105.5 81.5 104.157 81.5 102.5C81.5 100.843 80.1569 99.5 78.5 99.5C76.8431 99.5 75.5 100.843 75.5 102.5C75.5 104.157 76.8431 105.5 78.5 105.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 105.5C120.157 105.5 121.5 104.157 121.5 102.5C121.5 100.843 120.157 99.5 118.5 99.5C116.843 99.5 115.5 100.843 115.5 102.5C115.5 104.157 116.843 105.5 118.5 105.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M156 41L158 46L163 48L158 50L156 55L154 50L149 48L154 46L156 41Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M38.6 114.2C40.0359 114.2 41.2 113.036 41.2 111.6C41.2 110.164 40.0359 109 38.6 109C37.1641 109 36 110.164 36 111.6C36 113.036 37.1641 114.2 38.6 114.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
